var map = {
	"./AB-01.png": "f618",
	"./BAML-01.png": "cbc9",
	"./BCG-01.png": "910c",
	"./BainCo.png": "b8ab",
	"./CHANEL-01.png": "ddb0",
	"./Constellation-01.png": "4326",
	"./ELF-01.png": "b9a0",
	"./ESTEE-01.png": "085b",
	"./FourSig-01.png": "e205",
	"./J&JGrey-01.png": "3a3a",
	"./LCat-01.png": "7653",
	"./MOET-01.png": "df66",
	"./PK_full.png": "5859",
	"./PRIMAL-01.png": "e16f",
	"./TPG-01.png": "5388",
	"./YellowWood-01.png": "63f0",
	"./ZX-01.png": "8234",
	"./ZXX-01.png": "e6fe",
	"./barclays-logo.png": "8560",
	"./clorox.png": "60b5",
	"./coka-01.png": "98d6",
	"./diageo.png": "c76c",
	"./glam.png": "82f1",
	"./glam2-01.png": "3e43",
	"./kpmg.png": "e599",
	"./kraftHeinz.png": "72c7",
	"./pdc-01.png": "baf8",
	"./shisheido.png": "2e5f",
	"./wells-fargo.png": "08b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f6e";